import React from 'react';
import PropTypes from 'prop-types';

import { DynamicIcon } from '../common/dynamicIcon';

const SidebarMenuItem = ({ menuName, menuLink, menuIcon, onClick }) => {
    if (menuLink) {
        return (
            <li className="ab-sidebar-menu-item">
                <a href={menuLink} target="_blank" rel="noopener noreferrer">
                    <DynamicIcon name={menuIcon} size={36} />
                    <span className="ab-sidebar-menu-text">{menuName}</span>
                </a>
            </li>
        );
    }
    return (
        <li className="ab-sidebar-menu-item" onClick={onClick}>
            <DynamicIcon name={menuIcon} size={36} />
            <span className="ab-sidebar-menu-text">{menuName}</span>
        </li>
    );
};

SidebarMenuItem.propTypes = {
    menuName: PropTypes.string,
    menuLink: PropTypes.string,
    menuIcon: PropTypes.string,
    onClick: PropTypes.func,
};

export default SidebarMenuItem;
